<div class="ticker-wrap">
    
        <div class="ticker">
            <ng-container *ngFor="let rate of currentRates">

                <div class="ticker__item">
                    <p class="price-value">
                   
                        <span>{{rate['categoryname']}} <span *ngIf="rate['goldcarottype']!=0">({{rate['goldcarottype']}} CRT)</span> :</span>
                        <span style="color:green;"><i class="fa fa-inr" ></i> {{rate['salerate']}}</span>&nbsp; | &nbsp;
              
                        <!-- <span> 
                          <i class="fa fa-long-arrow-up" aria-hidden="true" style="color:#14a50f;"></i>  
                            <i class="fa fa-long-arrow-down" aria-hidden="true" style="color:#cd0000;"></i>
              
                        </span> -->
                        <span style="color:Red;"><i class="fa fa-inr" ></i> {{rate['purchaserate']}}</span>
                        <!-- <span style="color:Red;"> |
                           <i class="fa fa-long-arrow-down" aria-hidden="true" style="color:#cd0000;"></i>
              
                        </span> -->
              
                    </p>
                  </div>
            <!-- <div class="ticker__item">
                <p class="price-value">
                    <span>Gold (22 CRT) :</span>
                    <span><i class="fa fa-inr"></i> 35000</span>
                    <span>
                        <i class="fa fa-long-arrow-up" aria-hidden="true" style="color:#14a50f;"></i>

                    </span>
                </p>

            </div>
            <div class="ticker__item">
                <p class="price-value">
                    <span>Silver :</span>
                    <span><i class="fa fa-inr"></i> 55000</span>
                    <span>
                        <i class="fa fa-long-arrow-up" aria-hidden="true" style="color:#14a50f;"></i>

                    </span>
                </p>

            </div>
            <div class="ticker__item">
                <p class="price-value">
                    <span>Platinum :</span>
                    <span><i class="fa fa-inr"></i> 70000</span>
                    <span>
                        <i class="fa fa-long-arrow-up" aria-hidden="true" style="color:#14a50f;"></i>

                    </span>
                </p>

            </div>
            <div class="ticker__item">
                <p class="price-value">
                    <span>Gold (24 CRT) :</span>
                    <span><i class="fa fa-inr"></i> 2000</span>
                    <span>
                        <i class="fa fa-long-arrow-up" aria-hidden="true" style="color:#14a50f;"></i>

                    </span>
                </p>

            </div>
            <div class="ticker__item">
                <p class="price-value">
                    <span>Gold (22 CRT) :</span>
                    <span><i class="fa fa-inr"></i> 2000</span>
                    <span>
                        <i class="fa fa-long-arrow-up" aria-hidden="true" style="color:#14a50f;"></i>

                    </span>
                </p>

            </div> -->
        </ng-container>
    </div>
</div>